import React from 'react';
import Layout from '../components/Layout';
import Kvad from './Kvad';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';
import Section4 from './Section4';
import styled from 'styled-components';
import {breakPoint} from '../styles/var';

const ContentStyles = styled.div`
  .container {
    > .title {
      font-size: 3rem;
      margin-bottom: 2rem;
      letter-spacing: 2px;
    }
  }
  @media (min-width: ${breakPoint.min}) {
    .container {
      > .title {
        font-size: 4.2rem;
        margin-bottom: 3rem;
      }
    }
  }
  @media (max-width: ${breakPoint.smMax}) {
    .container {
      padding: 3rem 2rem;
      > .title {
        margin-bottom: 1.5rem;
      }
    }
  }
`;

const App = () => {
  return (
    <Layout>
      <Kvad id="Section1"/>
      <Section1 />
      <ContentStyles as={Section2} id="Section2" />
      <Section3 id="Section3" />
      <ContentStyles as={Section4} id="Section4" />
    </Layout>
  );
}

export default App;
